import route from "ziggy-js"
import { client } from "@/http"

export const api = {
  budgetCreate: (payload) => client.post(route("budgets.store"), payload),

  compassPay: (payload) => client.post(route("compass.pay"), payload),
  compassSetup: () => client.post(route("compass.setup")),

  listAdd: (id) => client.post(route("api.list.add"), { id }),
  listRemove: (id) => client.delete(route("api.list.remove"), { id }),

  podcastEpisodeList: (params) => client.get(route("api.podcasts.iatl.episodes"), { params }),
  podcastPlaylistList: (params) => client.get(route("api.podcasts.iatl.playlists"), { params }),

  reportCreate: (payload) => client.post(route("api.reports.store"), payload),

  schoolDetail: (slug) => client.get(route("api.schools.show", slug)),
  schoolList: (params) => client.get(route("api.schools.index"), { params }),

  stateList: (params) => client.get(route("api.states.index"), { params }),

  statePreferredAdd: (code) => client.post(route("api.states-preferred.add"), { code }),
  statePreferredRemove: (code) => client.delete(route("api.states-preferred.remove"), { code }),

  termList: (params) => client.get(route("api.terms.index"), { params }),
}
